import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import userReducer from "./feature/user/userSlice";
import resetPasswordReducer from "./feature/resetPassword/resetPasswordSlice";
import companyReducer from "./feature/company/companySlice";
import modalReducer from "./feature/modal/modalSlice";
import companySettingsSlice from "./feature/companySettings/companySettingsSlice";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  resetPassword: resetPasswordReducer,
  company: companyReducer,
  companySettings: companySettingsSlice,
  modal: modalReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export const persistedStore = persistStore(store);
